/**
 * Auth Logic Layer — Policy (terms & conditions)
 *
 * Owns: policy consent status check, accept + promote, promote-only.
 *
 * Rules:
 *  - No React, no navigate(), no notifications.
 *  - Uses pending token from localStorage for policy API calls.
 *  - Returns outcome objects so the UI can decide navigation.
 */
import {
  getMyPolicyConsentStatus as fetchPolicyStatus,
  submitMyPolicyConsent,
} from "../api/services/userPolicyConsentServices";
import { promotePendingSession } from "./session";

/**
 * Check whether the user must see the policy prompt.
 * Uses the pending token already in localStorage (the service reads it).
 *
 * @returns {Promise<{ needs_prompt: boolean, [key: string]: any }>}
 */
export async function getPolicyConsentStatus() {
  return fetchPolicyStatus();
}

/**
 * Accept policy decisions, then promote the pending session.
 *
 * @param {{ decisions: any }} payload
 * @returns {Promise<{ success: boolean, redirectPath: string }>}
 */
export async function acceptPolicyAndPromote({ decisions }) {
  await submitMyPolicyConsent({ decisions });

  const { redirectPath } = promotePendingSession();
  return { success: true, redirectPath };
}
